import React from "react";

import { getCorrespondingSort, isAsc } from "../../util/sort";

/**
 * Generic TableHeaderColumn Component
 *
 * @param {Object} props
 * @param {string} [props.id]
 * @param {string} [props.className]
 * @param {string} props.text
 * @param {function} [props.onClick]
 * @param {string} [props.title]
 * @param {number} [props.sortOption]
 * @param {number} [props.sortDesc]
 * @returns {React.JSX.Element}
 */
export default function TableHeaderColumn({ id, className, text, onClick, title, sortOption, sortDesc }) {
  let ariaSort, icon, ariaLabel, showIcon;

  if (sortOption && (sortOption === sortDesc || sortOption === getCorrespondingSort(sortDesc))) {
    const isAscending = isAsc(sortOption);
    const isDescending = isAsc(getCorrespondingSort(sortOption));

    if (isAscending) {
      ariaSort = "ascending";
      icon = "glyphicon glyphicon-arrow-up";
      ariaLabel = "sorted in A to Z order";
      showIcon = true;
    } else if (isDescending) {
      ariaSort = "descending";
      icon = "glyphicon glyphicon-arrow-down";
      ariaLabel = "sorted in Z to A order";
      showIcon = true;
    } else {
      ariaSort = "none";
    }
  }

  if (title && sortOption) {
    if (sortOption === sortDesc) {
      title = `Sort by ${title} ascending`;
    } else {
      title = `Sort by ${title} descending`;
    }
  }

  return (
    <th id={id} className={className} role="columnheader">
      {onClick ? (
        <a role="button" title={title} aria-sort={ariaSort} onClick={onClick} className="clickable" href="javascript:;">
          {text}
          {showIcon && (
            <span aria-label={ariaLabel}>
              <i className={icon}></i>
            </span>
          )}
        </a>
      ) : (
        text
      )}
    </th>
  );
}
